export const ONBOARDING_HINT_STEP = 'onboarding_hint_step';

export const SHOW_DEEP_RESEARCH_HINT = 'show_deep_research_hint';

export const SHOWN_ONBOARDING_MODAL = 'shown_onboarding_modal';

export const LOCAL_STORAGE_VALUE = '1';

export const GUEST_ACCESS_TOKEN = 'guest_access_token';

export const REDIRECT_TO_STRIPE_TIMESTAMP = 'redirect_to_stripe_timestamp';

export const TRANSACTION_ID = 'transaction_id';

export const PAYPAL_PAYMENT_IN_PROGRESS = 'paypal_payment_in_progress';

export const INVITATION_TOKEN = 'invitation_token';

export const DO_NOT_SHOW_BASIC_WELCOME_MODAL =
  'do_not_show_basic_welcome_modal';

export const REDIRECT_FROM = 'redirect_from';

export const REFERRAL_ID = 'referral_id';
